/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ContainerProps, $Sprite} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';
import {LabelShowManager} from './LabelShowManager';
import {Point, Container as PixiContainer} from 'pixi.js';
import {METER_TEXT_FIELD_ID, WinMeterManager} from './WinMeterManager';
import {RichText, Store} from '@gongxigames/framework/core';
import {uiTickerStore} from '@gongxigames/framework/slotV2/ui/services/UITicker/uiTickerStore';
import {TICKER_TEXT_FIELD_ID} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/components/WinArea/TickerManager';

export const $WinAreaLandscape: FC<ContainerProps> = (props) => {
    const winMeter = <$UIText
        localeID='winLandscape'
        name={METER_TEXT_FIELD_ID}
        stylePreset='WIN_VALUE_LABEL'
        maxWidth={440}
    />;

    const style = Store.computed(() => {
        return {fill: uiTickerStore.color.value};
    });

    const textField = <$UIText
        name={TICKER_TEXT_FIELD_ID}
        stylePreset='TICKER_VALUE'
        maxWidth={440}
        style={style}
        text={uiTickerStore.text}
    />;

    const textFields = [{
        id: METER_TEXT_FIELD_ID,
        container: winMeter as PixiContainer,
        backPosition: new Point(0, -10),
    },
    {
        id: TICKER_TEXT_FIELD_ID,
        container: textField as PixiContainer,
        backPosition: new Point(0, 34),
    }];

    const labelShowManager = new LabelShowManager(new Point(), textFields);

    // do not remove
    new WinMeterManager(labelShowManager, winMeter as RichText);

    return <$Container name='win_area_landscape' {...props}>
        <$Sprite texture='win_background_sys_ui' anchor={0.5}/>
        {winMeter}
        {textField}
    </$Container>;
};